import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export const WelcomePopup = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const hasSeenPopup = localStorage.getItem("hasSeenWelcomePopup");
    // La pàgina interna /dades no l'ensenya: no és una visita a la web.
    if (!hasSeenPopup && location.pathname !== "/dades") {
      setIsOpen(true);
      setTimeout(() => setIsVisible(true), 10);
    }

    const handleKeyPress = (event: KeyboardEvent) => {
      if (event.key === "i" || event.key === "I") {
        setIsOpen(true);
        setTimeout(() => setIsVisible(true), 10);
      }
    };

    window.addEventListener("keydown", handleKeyPress);
    return () => window.removeEventListener("keydown", handleKeyPress);
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => {
      setIsOpen(false);
      localStorage.setItem("hasSeenWelcomePopup", "true");
    }, 200);
  };

  if (!isOpen) return null;

  const sectionLabelClass = "px-5 pt-4 pb-1 text-xs font-semibold text-muted-foreground uppercase tracking-wide";
  const pageRowClass = "flex items-center gap-3 px-5 py-2";
  const pillClass =
    "shrink-0 px-2 py-0.5 rounded-md bg-secondary text-foreground text-xs font-mono whitespace-nowrap";

  const pages: { href: string; label: string; desc: string }[] = [
    { href: "/", label: "/Inici", desc: "Cerca i filtra tots els cotxes." },
    { href: "/comparador", label: "/Comparador", desc: "Compara fitxes tècniques en paral·lel." },
    { href: "/grups", label: "/Grups", desc: "Marques agrupades per grup automobilístic." },
    { href: "/novetats", label: "/Novetats", desc: "Cotxes i concepts anunciats recentment." },
    { href: "/histories", label: "/Històries", desc: "La història de les marques, amb fotos." },
    { href: "/guia-models", label: "/Guia Models", desc: "Cada model explicat." },
    { href: "/guia-matricules", label: "/Guia Matricules", desc: "Codis de matrícula de cada país i el seu significat." },
    { href: "/preferits", label: "/Preferits", desc: "Cotxes que m'agraden." },
    { href: "/ultima-matricula", label: "/Última Matrícula", desc: "Última matrícula vista." },
    { href: "/galeria", label: "/Galeria", desc: "Fotos de cotxes que he fet." },
  ];

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center p-4 transition-all duration-200 ${
        isVisible ? "bg-black/40 backdrop-blur-sm" : "bg-transparent backdrop-blur-none"
      }`}
      onClick={handleClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className={`bg-background border border-border rounded-2xl shadow-xl w-full max-w-md transition-all duration-200 max-h-[90vh] overflow-y-auto ${
          isVisible ? "opacity-100 scale-100" : "opacity-0 scale-95"
        }`}
      >
        {/* Header */}
        <div className="px-5 pt-5 pb-3">
          <p className="text-xs font-semibold text-muted-foreground uppercase tracking-wide">Benvingut/da.</p>
          <p className="text-2xl font-bold text-foreground mt-1">
            Cotx<span className="mx-[-1px]">.</span>es
          </p>
          <p className="text-sm text-muted-foreground mt-2 whitespace-nowrap overflow-hidden text-ellipsis">
            El directori amb tots els cotxes a venda i descatalogats.
          </p>
        </div>

        <div className="border-t border-border" />

        {/* Pages */}
        <div className="pb-2">
          <p className={sectionLabelClass}>Pàgines</p>
          {pages.map((page) => (
            <Link key={page.href} to={page.href} onClick={handleClose} className={`${pageRowClass} hover:bg-secondary transition-colors`}>
              <span className={pillClass}>{page.label}</span>
              <span className="text-sm text-muted-foreground whitespace-nowrap overflow-hidden text-ellipsis">{page.desc}</span>
            </Link>
          ))}
        </div>

        {/* Footer */}
        <div className="px-5 py-3 border-t border-border">
          <div className="flex gap-3 text-xs text-muted-foreground mb-3">
            <span className="flex items-center gap-1">
              <span className="inline-block w-1.5 h-1.5 rounded-full bg-green-500"></span>
              +700 en venda
            </span>
            <span className="flex items-center gap-1">
              <span className="inline-block w-1.5 h-1.5 rounded-full bg-red-500"></span>
              +1.300 descatalogats
            </span>
          </div>
          <button
            onClick={handleClose}
            className="w-full py-2.5 rounded-xl bg-foreground text-background text-sm font-semibold hover:opacity-90 transition-opacity"
          >
            Entra
          </button>
        </div>
      </div>
    </div>
  );
};
